module.exports = __webpack_public_path__ + "static/fonts/Nexa_Light.1be8e55.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Nexa/Nexa_Light.otf
// module id = 3Hgn
// module chunks = 3